// extracted by mini-css-extract-plugin
export default {"submitBtn":"AddPost_submitBtn__ouF4f"};